export { default } from './PatientImportantNotesAccordion';
